import { trFold } from "@/lib/trFold";

// Whitespace-insensitive, Turkish-folded char index for one page's text items.
export function buildPageIndex(items) {
  let text = "";
  const map = [];
  items.forEach((it, itemIdx) => {
    const str = it.str || "";
    for (let j = 0; j < str.length; j++) {
      const ch = str[j];
      if (/\s/.test(ch)) continue;
      const f = trFold(ch);
      for (const c of f) { text += c; map.push([itemIdx, j]); }
    }
  });
  return { text, map };
}

export function normalizeQuery(q) {
  return trFold(q).replace(/\s+/g, "");
}

// Returns [{ page, ranges: [{ itemIdx, from, to }] }] for every match across pages.
export function findMatches(indexes, query) {
  const q = normalizeQuery(query);
  if (!q) return [];
  const out = [];
  indexes.forEach((idx, p) => {
    if (!idx) return;
    let pos = idx.text.indexOf(q);
    while (pos !== -1) {
      const byItem = new Map();
      for (let k = pos; k < pos + q.length; k++) {
        const [itemIdx, ch] = idx.map[k];
        const r = byItem.get(itemIdx);
        if (r) r.to = ch + 1; else byItem.set(itemIdx, { itemIdx, from: ch, to: ch + 1 });
      }
      out.push({ page: p, ranges: [...byItem.values()] });
      pos = idx.text.indexOf(q, pos + q.length);
    }
  });
  return out;
}
